import { render, staticRenderFns } from "./liquidacionComisiones.vue?vue&type=template&id=e5c81228"
import script from "./liquidacionComisiones.vue?vue&type=script&lang=js"
export * from "./liquidacionComisiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports